import React, {  useContext, useEffect } from "react";
import { AppContext, DispatchContext} from '../../AppContext';
import TitleBarComponent from '../../components/titleBar';
import * as actions from "../../actions/actions";

export default function ToolComponent(props) {
    const state = useContext(AppContext);
    const dispatch = useContext(DispatchContext);

    useEffect(() => {
        if(state.ui.pageName !== window.location.pathname ){
            dispatch(actions.navigate_to(window.location.pathname))
        }   
    }, []);

    return (
        <div>Placeholder</div>
    )
}